var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M2 20.5h20m-20-2h17a1.5 1.5 0 0 0 1.5-1.5c0-.238-.061-.461-.16-.661l-2.104-5.801C17.627 8.774 15.97 7.5 14 7.5H2m5.5 7h4v-4h-4v4Zm-5.5-4h3.5v4H2m8-7 3-2-3-2-3 2 3 2m6.5 11a2 2 0 0 1-4 0m-5 0a2 2 0 0 1-4 0m14.736-7.963-.017-.037H13.5v4h6.173"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainDay);
export default __webpack_public_path__ + "static/media/train-day.16c023aa52bfc369d44a6a3e444b7958.svg";
export { ForwardRef as ReactComponent };